export default __webpack_public_path__ + "images/5bb677411390a037a6108915ca0c1dca.svg";